import React, { useRef, useEffect, useContext } from 'react'
import { components } from 'cng-web-lib'
import CngSection from '../../../../components/cngcomponents/CngSection'
import { Box, Grid, Tooltip, Divider } from '@material-ui/core'
import { useFormContext, useWatch } from 'react-hook-form'
import _ from 'lodash'
import ContainerInfoFormProperties from './../ContainerInfoFormProperties'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import { FdaPNTranslationContext } from './../../contexts/FDAPNTranslationContext.js'
import ContainerInfoEntry from './../ContainerInfoEntry'

const {
  button: { CngIconButton },
  form: {
    field: {
      CngSelectField,
      CngTextField,
      CngUomAutocompleteField
    },
  },
  CngGridItem
} = components

const { initialValues } = ContainerInfoFormProperties.formikProps

function ContainerSection(props) {
  const containerInfo = useWatch({ name: 'containerInfo' })
  const { showNotification, title, crewSectionHelper, shouldHideMap } = props

  const { getValues, setValue } = useFormContext()
  const lastIndex = useRef(containerInfo.length)
  const { getTranslatedText } = useContext(FdaPNTranslationContext)

  function handleAddContainer(data) {
    const containerList = [...getValues('containerInfo'), data].map(
      (container, index) => ({ ...container, _id: index + 1 })
    )
    setValue('containerInfo', containerList)
  }

  function handleDeleteContainer(data) {
    const clonedContainerList = [...getValues('containerInfo')].filter(
      (container) => container.id ? container.id !== data.id : container._id !== data._id
    )
    const containerList = clonedContainerList.map(
      (container, index) => ({ ...container, _id: index + 1 })
    )
    setValue('containerInfo', containerList)
  }

  return (
    <CngSection title={getTranslatedText('FDAPN', 'containerInfoTitle')} helperText={crewSectionHelper} alignItems='flex-end'>
      <Box display='flex' flexDirection='column' style={{ gap: 8 }}>
        {containerInfo.map((containerDTO, index) => (
          <React.Fragment key={containerDTO._id || containerDTO.id || index}>
            <Grid item xs={12}>
              <ContainerInfoEntry
                index={index}
                isLast={containerInfo.length === 1}
                onAddContainer={handleAddContainer}
                onDeleteContainer={handleDeleteContainer}
                containerDTO={containerDTO}
                showNotification={showNotification}
                shouldHideMap={shouldHideMap}
              />
            </Grid>
            {containerInfo.length !== index + 1 && <Divider />}
          </React.Fragment>
        ))}
      </Box>
      {containerInfo.length === 0 && (
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Add new'>
                <span>
                  <CngIconButton
                    icon={['fal', 'plus']}
                    onClick={() => handleAddContainer(initialValues)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      )}
    </CngSection>
  )
}

export default ContainerSection
